export function parseIriToId(url) {
    console.log(url)
    const parts = url.split('/')
    return parts[parts.length - 1]
}